import { IPromise } from "angular";
import { StateService, StateParams } from "@uirouter/angularjs";
import { IModalServiceInstance, IModalScope } from "angular-ui-bootstrap";
import { IHubFilter } from "../models/hub";
import { IAssigneeIdMap } from "@gtmhub/assignees/models";
import { HubService } from "../services/hub";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { IStateInit } from "@gtmhub/core/routing";
import { AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { INgRedux } from "@gtmhub/state-management";

interface IFilterFormScope extends IModalScope {
  filter: IHubFilter;
  indicators: {
    get: boolean;
    save: boolean;
  };
  selectAssigneesModal: IModalServiceInstance;
  assigneesIdMap: IAssigneeIdMap;
  filterIds: string[];
  save(): void;
  selectMultipleOwners(ids: string[]): void;
}

const bindStateToScope = (state: IAssigneesStoreState) => ({
  assigneesIdMap: state.assignees.map,
});
export class FilterFormCtrl implements IStateInit {
  public static $inject = ["$rootScope", "$scope", "$stateParams", "$state", "HubService", "UIErrorHandlingService", "AssigneeActions", "$ngRedux"];

  constructor(
    private $rootScope: IGtmhubRootScopeService,
    private $scope: IFilterFormScope,
    private $stateParams: StateParams,
    private $state: StateService,
    private hubService: HubService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private assigneeActions: AssigneeActions,
    private $ngRedux: INgRedux
  ) {
    this.$scope.indicators = { get: true, save: false };

    this.$scope.save = this.save;
    this.$scope.selectMultipleOwners = this.selectMultipleOwners;

    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(this.$scope);
    this.$scope.$on("$destroy", unsubscribe);
  }

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private getFilter(): IPromise<unknown> {
    return this.hubService.getFilter(this.$stateParams.formFilterId).then(
      (filter) => {
        if (this.$stateParams.formFilterId) {
          if (!filter.employeeIds) {
            filter.employeeIds = [];
          }

          this.$scope.filter = filter;

          let ids = [];
          if (filter.teamIds) {
            ids = ids.concat(filter.teamIds);
          }
          if (filter.employeeIds) {
            ids = ids.concat(filter.employeeIds);
          }

          this.$scope.filterIds = ids;
        }

        this.$scope.indicators.get = false;
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "get" })
    );
  }

  private init = (): IPromise<unknown> => {
    this.$ngRedux.dispatch(this.assigneeActions.getAssignees());

    if (!this.$stateParams.formFilterId) {
      this.$scope.filter = {
        name: "",
        employeeIds: [],
        teamIds: [],
        filterType: "hub",
      };

      this.$scope.indicators.get = false;
    } else {
      return this.getFilter();
    }
  };

  private selectMultipleOwners = (ids: string[]): void => {
    this.$scope.filter.employeeIds = ids;
  };

  private save = () => {
    if (this.$stateParams.formFilterId) {
      this.patch();
    } else {
      this.create();
    }
  };

  private create = () => {
    this.$scope.indicators.save = true;
    this.hubService.createFilter(this.$scope.filter).then((newfilter) => {
      this.$scope.indicators.save = false;
      this.$rootScope.$broadcast("filtersChanged");

      if (this.$rootScope.featureAvailable("hub.tasks")) {
        const goToStateName = this.$rootScope.isMsTeamsState ? "gtmhub.msteams.tasks" : "gtmhub.tasks";
        this.$state.go(goToStateName, { filterId: newfilter.id });
      } else {
        this.$scope.$close();
      }
    });
  };

  private patch = () => {
    this.$scope.indicators.save = true;
    this.hubService.patchFilter(this.$scope.filter.id, this.$scope.filter).then(
      () => {
        this.$scope.indicators.save = false;
        this.$rootScope.$broadcast("filterChanged", this.$scope.filter);
        this.$rootScope.$broadcast("filtersChanged");
        this.$scope.$close();
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "save" })
    );
  };
}
